import {
  BoltIcon,
  Breadcrumb,
  BuildingLibraryIcon,
  Button,
  CalendarDaysIcon,
  CloudArrowDownIcon,
  Input,
  PageHero,
  useCanShow,
  useCustomForm,
} from "@";
import { useExportNationalCenterReportMutation } from "./utils/mutations";
import { defaultValues, schema } from "./utils/validation";

const links = [
  { name: "التبرعات", link: "/donations" },
  { name: "التقارير", link: "" },
];

const Index = () => {
  const { watch, errors, setValue, register, handleSubmit } = useCustomForm(
    defaultValues,
    schema,
  );

  const exportMutation = useExportNationalCenterReportMutation();

  const submit = (values) => exportMutation.mutateAsync(values);

  return (
    <>
      <Breadcrumb links={links} />

      <main className="table-card relative pb-5">
        <PageHero
          eyebrow="التقارير / المركز الوطني"
          title="تقارير الجمع للمركز الوطني"
          icon={BuildingLibraryIcon}
        />

        {/* Hero info card */}
        <div className="mt-4 grid gap-4 lg:grid-cols-[1fr_minmax(0,_1.4fr)]">
          <aside className="relative overflow-hidden rounded-2xl border border-purple-100 bg-gradient-to-br from-purple-50/60 via-white to-purple-50/30 p-5 dark:border-purple-800/40 dark:from-purple-950/40 dark:via-gray-800 dark:to-purple-950/20">
            <div className="relative flex items-start gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-md shadow-purple-900/25 ring-1 ring-purple-900/10 dark:from-purple-600 dark:to-purple-800">
                <CloudArrowDownIcon className="h-5 w-5" />
              </span>
              <div>
                <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-700 dark:text-purple-400">
                  دليل سريع
                </p>
                <h3 className="mt-0.5 text-base font-bold tracking-tight text-gray-900 dark:text-gray-100">
                  تصدير تقرير المركز الوطني
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                  اختر النطاق الزمني الذي ترغب في تحميل تقريره ثم انقر على زر
                  <span className="mx-1 font-semibold text-purple-700 dark:text-purple-300">
                    تصدير التقرير
                  </span>
                  لتنزيل ملف أكسل مفصّل.
                </p>
                <ul className="mt-3 space-y-1.5 text-xs text-gray-500 dark:text-gray-400">
                  <li className="flex items-center gap-2">
                    <BoltIcon className="h-3.5 w-3.5 text-purple-500 dark:text-purple-400" />
                    التقرير يشمل التبرعات المسجّلة خلال الفترة المحددة فقط
                  </li>
                  <li className="flex items-center gap-2">
                    <CalendarDaysIcon className="h-3.5 w-3.5 text-purple-500 dark:text-purple-400" />
                    تاكد من اضافة تراخيص المشاريع اولا
                  </li>
                </ul>
              </div>
            </div>
          </aside>

          {/* Form card */}
          <form
            onSubmit={handleSubmit(submit)}
            className="relative flex flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-5 dark:border-gray-700/60 dark:bg-gray-800"
          >
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-purple-50 text-purple-700 ring-1 ring-purple-100 dark:bg-purple-950/40 dark:text-purple-300 dark:ring-purple-800/40">
                <CalendarDaysIcon className="h-5 w-5" />
              </span>
              <div>
                <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-purple-700 dark:text-purple-400">
                  الفترة الزمنية
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  حدد البداية والنهاية
                </p>
              </div>
            </div>

            <Input
              showTimeSelect
              type="date-range"
              labelA="من تاريخ"
              labelB="الي تاريخ"
              valueA={watch("fromDate")}
              valueB={watch("toDate")}
              inputA={register("fromDate")}
              inputB={register("toDate")}
              errorA={errors.fromDate}
              errorB={errors.toDate}
              changeA={(e) => setValue("fromDate", e, { shouldValidate: true })}
              changeB={(e) => setValue("toDate", e, { shouldValidate: true })}
            />

            {useCanShow("exportData") && (
              <div className="mt-2 flex items-center justify-end">
                <Button
                  type="submit"
                  title="تصدير التقرير"
                  isLoading={exportMutation.isPending}
                >
                  <CloudArrowDownIcon className="h-5 w-5" />
                </Button>
              </div>
            )}
          </form>
        </div>
      </main>
    </>
  );
};

export default Index;
